import React from 'react';

const SharedBedroom = props => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width={75}
    height={81}
    x={0}
    y={0}
    viewBox="0 0 112.3 119.4"
    style={{
      enableBackground: 'new 0 0 112.3 119.4'
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.st0{fill:#fff}.st1{fill:#f87052}.st2{fill:#647a85}.st3{fill:#224251}'}</style>
    <path className="st0" d="M107.2 28.8H5v15.8h102.2V28.8zM107.2 81.3H5v15.8h102.2V81.3z" />
    <path className="st1" d="M107.2 33.8H5v21.6h102.2V33.8zM107.2 86.3H5v21.6h102.2V86.3z" />
    <path
      className="st2"
      d="M95 49.7H73.4c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4H95c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4zM95 64H73.4c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4H95c.8 0 1.4.6 1.4 1.4S95.8 64 95 64zM95 78.4H73.4c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4H95c.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4zM95 92.8H73.4c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4H95c.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4zM95 107.2H73.4c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4H95c.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4z"
    />
    <path
      className="st3"
      d="M8.6 119.4H1.4c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4h7.2c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4zM110.8 119.4h-7.2c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4h7.2c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4z"
    />
    <path
      className="st2"
      d="M95 119.4c-.8 0-1.4-.6-1.4-1.4V33.8c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4V118c0 .8-.6 1.4-1.4 1.4zM73.4 119.4c-.8 0-1.4-.6-1.4-1.4V33.8c0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4V118c0 .8-.6 1.4-1.4 1.4z"
    />
    <path
      d="M30.2 79.9c0-2.4-1.9-4.3-4.3-4.3h-9.4c-2.4 0-4.3 1.9-4.3 4.3v1.4h18v-1.4z"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        fill: '#fff'
      }}
    />
    <path
      className="st3"
      d="M107.2 13.7c-.8 0-1.4.6-1.4 1.4v12.2H31.7c0-3.2-2.6-5.8-5.8-5.8h-9.4c-3.2 0-5.8 2.6-5.8 5.8H6.5V1.4C6.5.6 5.8 0 5 0S3.6.7 3.6 1.4v111.5c0 .8.7 1.4 1.4 1.4.8 0 1.4-.7 1.4-1.4v-3.6h61.9c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H6.5V87.8h61.9c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H6.5v-2.1h61.9c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H31.7c0-3.2-2.6-5.8-5.8-5.8h-9.4c-3.2 0-5.8 2.6-5.8 5.8H6.5v-23h61.9c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4H6.5v-19h61.9c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H6.5v-2.2h99.3v2.2H100c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h5.8V54H100c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4h5.8v23H100c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h5.8v2.1H100c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h5.8v18.7H100c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h5.8v3.6c0 .8.6 1.4 1.4 1.4.8 0 1.4-.7 1.4-1.4V15.1c.1-.8-.6-1.4-1.4-1.4zM16.5 77h9.3c1.6 0 2.9 1.3 2.9 2.9h-15c0-1.6 1.3-2.9 2.8-2.9zm-2.8-49.7c0-1.6 1.3-2.9 2.9-2.9h9.3c1.6 0 2.9 1.3 2.9 2.9H13.7z"
    />
  </svg>
);

export default SharedBedroom;
